module.exports = __webpack_public_path__ + "static/img/appPreview.7c1239c.jpg";